import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getEntityDetails,
    postEntityDetails
} from '../../../../../../../actions/rof-burns/01-project-info/01-general-info';
import { formMaxWidth } from '../constants/general-info-constants';
import GeneralInfoForm from '../shared-components/GeneralInfoForm';

const defaultFormState = {
    organisationName: '',
    organisationAddress: '',
    organisationEmail: '',
    organisationLogo: null,
    clientName: '',
    clientAddress: '',
    clientContact: '',
    clientLogo: null,
}

export default function EntityDetails({ projectId, selectedCategory }) {
    const dispatch = useDispatch()
    const [formState, setFormState] = useState(defaultFormState)
    const [formErrors, setFormErrors] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [fileInputKey, setFileInputKey] = useState(0)

    const entityDetailsData = useSelector((state) => (state.generalInfoReducer.entityDetails?.data));

    useEffect(() => {
        handleFormErrorReset()
        dispatch(getEntityDetails(projectId))
    }, [selectedCategory, projectId])

    useEffect(() => {
        if (entityDetailsData)
            setFormState({
                organisationName: entityDetailsData?.organisation_name,
                organisationAddress: entityDetailsData?.organisation_address,
                organisationEmail: entityDetailsData?.organisation_email,
                organisationLogo: entityDetailsData?.organisation_logo,
                clientName: entityDetailsData?.client_name,
                clientAddress: entityDetailsData?.client_address,
                clientContact: entityDetailsData?.client_email,
                clientLogo: entityDetailsData?.client_logo,
            })
        else {
            setFormState(defaultFormState)
        }
    }, [selectedCategory, projectId, entityDetailsData])

    const entityDetailsQuestions = (formState) => {
        const { organisationName, organisationAddress, organisationEmail, organisationLogo,
            clientName, clientAddress, clientContact, clientLogo } = formState
        return [
            {
                type: 'text',
                text: 'Name of your organisation:',
                fieldId: 'organisationName',
                value: organisationName,
                placeholder: `Organisation's name`
            },
            {
                type: 'text',
                text: `Organisation's address:`,
                fieldId: 'organisationAddress',
                value: organisationAddress,
                placeholder: `Organisation's address`
            },
            {
                type: 'text',
                text: `Organisation's main contact e-mail:`,
                fieldId: 'organisationEmail',
                value: organisationEmail,
                placeholder: `Organisation's e-mail`
            },
            {
                type: 'file',
                text: `Organisation's logo:`,
                fieldId: 'organisationLogo',
                value: organisationLogo,
            },
            {
                type: 'text',
                text: `Client's name (individual or organization):`,
                fieldId: 'clientName',
                value: clientName,
                placeholder: 'Client name'
            },
            {
                type: 'text',
                text: `Client's address:`,
                fieldId: 'clientAddress',
                value: clientAddress,
                placeholder: `Client's address`
            },
            {
                type: 'text',
                text: `Client's primary e-mail:`,
                fieldId: 'clientContact',
                value: clientContact,
                placeholder: `Client's e-mail`
            },
            {
                type: 'file',
                text: `Client's logo:`,
                fieldId: 'clientLogo',
                value: clientLogo,
            },
        ]
    }

    const onSubmit = async () => {
        try {
            setIsLoading(true)

            const formData = createFormData(formState)

            await dispatch(postEntityDetails(formData, projectId))
            await dispatch(getEntityDetails(projectId))
            setFileInputKey((prevState) => (prevState + 1))
        } catch (error) {
            setFormErrors(error.message)
        } finally {
            setIsLoading(false)
        }
    }

    function createFormData(formState) {
        const formData = new FormData()

        formData.append('organisationName', formState.organisationName)
        formData.append('organisationAddress', formState.organisationAddress)
        formData.append('organisationEmail', formState.organisationEmail)
        formData.append('clientName', formState.clientName)
        formData.append('clientAddress', formState.clientAddress)
        formData.append('clientContact', formState.clientContact)

        if (formState.organisationLogo instanceof File) {
            formData.append('organisationLogo', formState.organisationLogo)
        }
        if (formState.clientLogo instanceof File) {
            formData.append('clientLogo', formState.clientLogo)
        }
        return formData
    }

    const setData = (event) => {
        const { name, type } = event.target;
        let value = event.target.value

        if (type === 'file') {
            value = event.target.files[0]
        }

        setFormState(prevState => ({
            ...prevState,
            [name]: value,
        }));
    }

    const handleFormErrorReset = () => {
        setFormErrors(null);
    };

    const questions = entityDetailsQuestions(formState)

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxWidth: formMaxWidth }}>
            <Typography variant='h4' sx={{ pb: 2 }}>
                {selectedCategory}
            </Typography>
            <GeneralInfoForm
                formObjectArray={questions}
                formState={formState}
                formErrors={formErrors}
                isLoading={isLoading}
                fileInputKey={fileInputKey}
                onChange={setData}
                onSubmit={onSubmit} />
        </Box>
    )
}